import { Link, useSearchParams } from 'react-router-dom';
import './SubscriptionCancelledPage.scss';

export function SubscriptionCancelledPage() {
  const [searchParams] = useSearchParams();
  const untilParam = searchParams.get('until');

  const accessUntil = (() => {
    if (!untilParam) return null;
    const date = new Date(untilParam);
    return isNaN(date.getTime()) ? null : date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  })();

  return (
    <main className="subscription-cancelled-page">
      <div className="subscription-cancelled-page__container">
        <div className="subscription-cancelled-page__content">
          <span className="subscription-cancelled-page__icon">👋</span>
          <h1 className="subscription-cancelled-page__title">Subscription cancelled</h1>
          {accessUntil && (
            <p className="subscription-cancelled-page__access-until">
              You still have Pro access until <strong>{accessUntil}</strong>.
            </p>
          )}
          <p className="subscription-cancelled-page__changes-heading">{accessUntil ? 'After that' : 'Your plan going forward'}</p>
          <ul className="subscription-cancelled-page__changes">
            <li className="subscription-cancelled-page__change">5 shares per day</li>
            <li className="subscription-cancelled-page__change">Up to 10MB per request</li>
          </ul>
          <Link to="/preferences" className="subscription-cancelled-page__cta">
            Go to preferences
          </Link>
        </div>
      </div>
    </main>
  );
}
